<template>
    <div  class="pet-details-modal" v-if="isOpen">
      <div
        class="overlay"
       
        :class="{ 'is-active': isOpen }"
      >
      
        <div class="overlay__inner">
          <v-card>
          <header class="pet-details__header">
            <div class="adoption-tool__header-container center-container">
              <div class="pet-details__header-top bg-lightblue">
                <h2 class="pet-details__main-title">{{ petDetails.name }}</h2>
                <!-- <h2 class="pet-details__main-title">{{ petData.petId }}</h2> -->
                <v-btn 
                  class="pet-details__close-button"
                  icon dark @click="petStore.closePetDetailsModal()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <!-- <button
                  class="pet-details__close-button"
                  @click.stop="petStore.closePetDetailsModal()"
                  small
                >
                  <v-icon dark> mdi-close </v-icon>
                </button> -->
              </div>
              <div class="pet-details__header-bottom">
                <span class="pet-details__header-info">
                  {{ petDetails.ageGroup }} {{ petDetails.sex }} /
                  {{ petDetails.breedString }}
                </span>
              </div>
            </div>
          </header>

          <section class="pet-details__swiper" v-if="petGallery">
            <div class="center-container nopad">
              <swiper
                :modules="modules"
                :slides-per-view="1"
                :space-between="50"
                navigation
                autoHeight
                :pagination="{ clickable: true }"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide
                  v-for="(imageUrl, index) in petGallery"
                  :key="`image-${index}`"
                >
                  <figure class="pet-details__slide-figure">
                    <img
                      class="pet-details__slide-image"
                      :src="imageUrl"
                      alt="pet image"
                    />
                  </figure>
                </swiper-slide>
              </swiper>
            </div>
          </section>

          <section
            class="pet-details__pet-image"
            v-if="!petGallery && petStore.petThumbById(petData.petId)"
          >
            <div class="center-container nopad text-align-center">
              <figure class="pet-details__pet-figure">
                <img
                  :src="petStore.petThumbById(petData.petId)"
                  alt="pet image"
                />
              </figure>
            </div>
          </section>

          <section
            class="pet-details__pet-image pet-details__pet-image--empty"
            v-if="!petGallery && !petStore.petThumbById(petData.petId)"
          >
            <div class="center-container nopad text-align-center">
              <figure class="pet-details__pet-figure">
                <img src="/src/assets/paw-transparent.png" alt="pet image" />
              </figure>
            </div>
          </section>

          <section class="pet-details__org-info">
            <div class="pet-details__org-info-container center-container">
              <div class="pet-details__org-info-box">
                <p class="pet-details__org-info-label">Location:</p>
                <div class="pet-details__org-info-tag">
                  {{ petOrgData.city }} , {{ petOrgData.state }}
                </div>
              </div>
              <div class="pet-details__org-info-box">
                <p class="pet-details__org-info-label">Organization:</p>
                <div class="pet-details__org-info-tag">
                  {{ petOrgData.name }}
                </div>
              </div>
            </div>
          </section>

          <section class="pet-details__tabs">
            <div class="center-container center-container--narrow">
              <v-card>
                <v-tabs v-model="tab" bg-color="#f1f1f1">
                  <v-tab value="one">Description</v-tab>
                  <v-tab value="two">Additional Info</v-tab>
                  <v-tab value="three">Contact</v-tab>
                </v-tabs>

                <v-card-text>
                  <v-window v-model="tab">
                    <v-window-item
                      value="one"
                      v-html="petDetails.descriptionText"
                    ></v-window-item>

                    <v-window-item value="two">
                      <ul class="pet-details__meta-list">
                        <li
                          class="pet-details__meta-item"
                          v-if="petDetails.isCurrentVaccinations"
                        >
                          <span class="pet-details__meta-label"
                            >Vaccinated</span
                          >
                        </li>

                        <li
                          class="pet-details__meta-item"
                          v-if="petDetails.isKidsOk"
                        >
                          <span class="pet-details__meta-label"
                            >Friendly with kids</span
                          >
                        </li>
                        <li
                          class="pet-details__meta-item"
                          v-if="petDetails.isDogsOk"
                        >
                          <span class="pet-details__meta-label"
                            >Friendly with other dogs</span
                          >
                        </li>
                        <li
                          class="pet-details__meta-item"
                          v-if="petDetails.isHouseTrained"
                        >
                          <span class="pet-details__meta-label"
                            >House Trained</span
                          >
                        </li>
                        <li
                          class="pet-details__meta-item"
                          v-if="petDetails.coatLength"
                        >
                          <span class="pet-details__meta-label"
                            >Coat Length:</span
                          >
                          <span>{{ petDetails.coatLength }}</span>
                        </li>
                      </ul>
                    </v-window-item>

                    <v-window-item value="three">
                      <div class="pet-details__contact-box">
                        <h3 class="pet-details__contact-title">
                          {{ petOrgData.name }}
                        </h3>
                        <div
                          class="pet-details__contact-item"
                          v-if="petOrgData.phone"
                        >
                          <span class="pet-details__contact-label">Phone: </span>
                          <span>{{ petOrgData.phone }}</span>
                        </div>
                        <div
                          class="pet-details__contact-item"
                          v-if="petOrgData.email"
                        >
                          <span class="pet-details__contact-label">Email: </span>
                          <a
                            :href="
                              'mailto:' +
                              petOrgData.email +
                              '?subject=Requesting info about ' +
                              petDetails.name
                            "
                            target="_blank"
                            ><span>{{ petOrgData.email }}</span></a
                          >
                        </div>
                        <div
                          class="pet-details__contact-item"
                          v-if="petOrgData.url"
                        >
                          <span class="pet-details__contact-label"
                            >Website: </span
                          >
                          <a :href="petOrgData.url" target="_blank"
                            ><span>{{ petOrgData.url }}</span></a
                          >
                        </div>
                        <div class="pet-details__contact-item">
                          <p class="pet-details__contact-label">Address:</p>
                          <p>{{ petOrgData.street }}</p>
                          <p>
                            {{ petOrgData.city }} , {{ petOrgData.state }},
                            {{ petOrgData.postalcode }}
                          </p>
                        </div>
                      </div>
                    </v-window-item>
                  </v-window>
                </v-card-text>
              </v-card>
            </div>
          </section>

        </v-card>
        </div>
   
      </div>
    </div>
 
</template>


<script>
import { usePetStore } from "../stores/PetStore";
// import Swiper core and required modules
import { Navigation, Pagination } from "swiper";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import pawImageUrl from '@/assets/paw-transparent.png'

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tab: null,
    };
  },
  setup() {
    const petStore = usePetStore();
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      petStore,
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination],
    };
  },
  computed: {
    pawImageUrl: () => pawImageUrl,
    isOpen: function () {
      return this.petStore.isPetDetailsModalOpen;
    },
    petData: function () {
      return this.petStore.getSelectedPetData;
    },
    petDetails: function () {
      return this.petStore.getSelectedPetData.details.attributes;
    },
    petOrgData: function () {
      return this.petStore.getSelectedPetData.petOrgData;
    },
    petGallery: function () {
      return this.petStore.petGalleryById(this.petData.petId);
    },
  },
};
</script>

<style lang="scss">
@import "scss/global/variables.scss";
@import "scss/global/mixins.scss";
@import "scss/global/breakpoints.scss";
@import "scss/global/layout.scss";
@import "scss/global/overlay.scss";
@import "scss/global/colors.scss";
@import "scss/global/fonts.scss";

.v-dialog--scrollable {
.v-overlay__scrim {
  background-color: #fff !important;
  opacity: 1 !important;
}
}

.pet-details-modal {
  position: relative;
  z-index: 30;
}

.pet-details {
  &__scrollcontainer {
    // max-height: 100vh;
    // overflow-y: auto;
  }

  &__header-top {
    padding: 10px;
    text-align: center;
    position: relative;
  }
  &__header-bottom {
    padding: 10px;
    text-align: center;
    background-color: #f4f4f4;
    border-bottom: $lightgreyborder;
    // box-shadow: -1px 2px 7px 0px rgb(2 3 3 / 10%);
  }

  &__main-title {
    font-size: rem(32);
    font-weight: bold;
  }
  &__close-button {
    position: absolute !important;
    @include acent('v');
    right: 5px;
    // width: 30px;
    // height: 30px;
    // background-color: #fff;
    // border-radius: 50%;
    // border: 1px solid rgba(151, 140, 131, 0.18);
    // box-shadow: 0 0 9.5px 0 rgb(2 3 3 / 10%);
    // i {
    //   @include acent();
    //   font-size: 18px;
    // }
  }
  &__org-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
  }
  &__org-info-box {
    margin: 0 5px;
    text-align: center;
  }
  &__org-info-label {
    font-size: rem(12);
    margin-bottom: 0.5em;
  }
  &__org-info-tag {
    display: inline-block;
    padding: 8px;
    font-size: rem(13);
    background-color: $lightgrey;
    border: 1px solid $lightgreyborder;
    box-shadow: 0px 0.5px 3.5px 0 rgba(2, 3, 3, 0.1);
    border-radius: 4px;
  }
  &__tabs {
    margin-bottom: 40px;
    .v-tab.v-tab.v-tab {
      width: 33.3333%;
    }
    .v-btn__content {
      font-size: rem(13);
      text-transform: none;
    }
    .v-tab__slider {
      height: 1px;
    }
    .v-card-text {
      border: 1px solid $lightgreyborder;
    }
  }
  &__swiper {
    .swiper-slide {
      @include tablet {
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: stretch;
      }
    }
  }
  &__slide-figure {
    margin: 0;
    img {
      display: block;
      width: 100%;
      height: auto;
      @include tablet {
        height: 100%;
        width: auto;
      }
    }
  }
  &__pet-image {
    img {
      width: 100vw;
      height: auto;
      @include desktop {
        max-width: 500px;
      }
    }
    &--empty {
      padding: 40px;
      img {
        max-width: 100%;
        @include desktop {
          max-width: 300px;
        }
      }
    }
  }
  &__contact-title {
    margin-bottom: 0.5em;
    font-size: rem(20);
    font-weight: bold;
  }
  &__contact-item {
    margin-bottom: 0.5rem;
  }
  &__contact-label {
    font-weight: bold;
  }
  &__meta-item {
    display: block;
    margin-bottom: 0.5rem;
    text-align: center;
    padding: 8px;
    font-size: rem(13);
    background-color: $lightgreen;
    border: 1px solid $lightgreyborder;
    box-shadow: 0px 0.5px 3.5px 0 rgba(2, 3, 3, 0.1);
    border-radius: 4px;
  }
}
</style>
